<div class="my-3 my-md-5">
    <div class="container-fluid">
        <div class="col-sm-3 col-sm float-left">
            <h1 class="page-title">Products</h1>
        </div>
        <div class="col-sm-3 float-right">
            <span *ngIf="role=='1'">
                <div><a class="float-right btn btn-success text-white" (click)="showModalProduct()"><i class="fa fa-file-excel"></i> Import Products</a><br><br>
                <a class="float-right" href="{{sc3Url}}crm/products/products_imports.csv" target="_blank">Sample CSV</a></div> <br>
            </span>
            <div class="col-sm-6 float-right">
                <span *ngIf="role=='1'">
                    <div><a class="float-right btn btn-success text-white" (click)="showModalProduct2()"><i class="fa fa-file-excel"></i> Import Products With Leads</a><br><br>
                    <a class="float-right" href="{{sc3Url}}crm/products/products_imports.csv" target="_blank">Sample CSV</a></div> <br>
                </span>
            </div>
        </div>
    </div>

    <div class="container-fluid px-4 pt-4 card">
        <mat-accordion class="example-headers-align" multi>
            <mat-expansion-panel>
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        <i class="fas fa-sliders-h"></i> <span class="pl-2">Filters</span>
                    </mat-panel-title>
                </mat-expansion-panel-header>
                <div class="row mb-3 mt-3">
                    <div class="col-sm-3 mt-1"><input class="form-control" [(ngModel)]="search" type="text"
                            placeholder="Search" />
                    </div>

                    <div class="col-sm-3 mt-1">
                        <mat-select placeholder="Circle" [(ngModel)]="circle" (click)="setSearchValue('circle')"
                            multiple>
                            <input class="mySearchInput" #circleSearch focused="'true'" type="text"
                                (keyup)="searchOnSelect($event.target.value, 'circle')"
                                (keydown)="$event.stopPropagation()" autocomplete="off" placeholder="Search"
                                id="circleSearch">
                            <mat-option value="{{cir.id}}" *ngFor="let cir of circles">{{cir.name}}</mat-option>
                        </mat-select>
                    </div>

                    <div class="col-sm-3 mt-1" *ngIf="role=='1' || role=='3' || role=='6' || role=='8'">
                        <mat-select  placeholder="Lead Owner" [(ngModel)]="bd" (click)="setSearchValue('bds')" multiple #itemSelect="ngModel">
                            <input class="mySearchInput"
                            #bd_search focused="'true'" type="text"
                            (keyup)="searchOnSelect($event.target.value, 'bds')"
                            (keydown)="$event.stopPropagation()" autocomplete="off"
                            placeholder="Search"
                            id="bd_search">
                            <mat-option value="{{bd.id}}" *ngFor="let bd of bds">{{bd.name}}</mat-option>
                        </mat-select>
                    </div>

                    <div class="col-sm-3 mt-1" *ngIf="role=='1' || role=='3' || role=='6' || role=='8'">
                        <mat-select  placeholder="Booking Owner" [(ngModel)]="created_by" (click)="setSearchValue('bds')" multiple #itemSelect="ngModel">
                            <input class="mySearchInput"
                            #bd_search focused="'true'" type="text"
                            (keyup)="searchOnSelect($event.target.value, 'bds')"
                            (keydown)="$event.stopPropagation()" autocomplete="off"
                            placeholder="Search"
                            id="bd_search">
                            <mat-option value="{{bd.id}}" *ngFor="let bd of bds">{{bd.name}}</mat-option>
                        </mat-select>
                    </div>

                    <div class="col-sm-3 mt-5">
                        <mat-select  placeholder="Treatment" [(ngModel)]="treatment" (click)="setSearchValue('treatment')" multiple>
                            <input class="mySearchInput"
                            #treatmentSearch focused="'true'" type="text"
                            (keyup)="searchOnSelect($event.target.value, 'treatment')"
                            (keydown)="$event.stopPropagation()" autocomplete="off"
                            placeholder="Search"
                            id="treatmentSearch">
                            <mat-option value="{{ltreatment.id}}" *ngFor="let ltreatment of treatments">{{ltreatment.name}}</mat-option>
                        </mat-select>
                    </div>

                    <div class="col-sm-3 mt-5">
                        <mat-select  placeholder="Status" [(ngModel)]="status" multiple>
                            <mat-option value="1">New</mat-option>
                            <mat-option value="2">Verified</mat-option>
                            <mat-option value="3">Pending</mat-option>
                            <mat-option value="4">RTO</mat-option>
                            <mat-option value="5">Delivered</mat-option>
                            <mat-option value="6">Postponed</mat-option>
                            <mat-option value="7">Dispatched</mat-option>
                            <mat-option value="8">Cancelled</mat-option>
                        </mat-select>
                    </div>

                    <div class="col-sm-3 mt-4">
                        <mat-form-field appearance="fill">
                            <mat-label>Booking date range</mat-label>
                            <mat-date-range-input [rangePicker]="picker">
                                <input matStartDate #dateRangeStart placeholder="Start date">
                                <input matEndDate #dateRangeEnd placeholder="End date"
                                    (dateChange)="dateRangeChange(dateRangeStart, dateRangeEnd)">
                            </mat-date-range-input>
                            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                            <mat-date-range-picker #picker></mat-date-range-picker>
                        </mat-form-field>
                        <mat-icon (click)="clearDate()">clear</mat-icon>
                    </div>

                    <div class="col-sm-3 mt-5">
                        <button type="button" class="btn btn-primary ml-2 mb-4" (click)="loadProducts(0,perpage)"> <i
                                class="fa fa-search" aria-hidden="true"></i> Search Data</button>
                        <button type="button" class="btn btn-primary ml-2 mb-4" (click)="resetFilters()"> <i
                                class="fa fa-sync"></i> Reset Filters</button>
                    </div>
                </div>
            </mat-expansion-panel>
        </mat-accordion>
        <div class="card">
            <div class="container-fluid row">
                <div class="col-sm-6 p-3"><button type="button" class="btn btn-success" [disabled]="loading"
                        (click)="loadProducts(0,perpage)"><i class="fa fa-sync" [ngClass]="{'fa-spin':loading}"></i>
                        Refresh List</button>
                        <button  *ngIf="role=='1'" type="button" class="btn btn-success ml-2" [disabled]="loading" (click)="exportProductList()"><i class="fa fa-file-excel"></i> Export List</button>
                    </div>
                <div class="col-sm-6">
                    <mat-paginator #paginatorTop [length]="length" [pageSizeOptions]="pageSizeOptions"
                        [pageSize]="perpage"
                        (page)="pageEvent = getServerData($event);paginatorBottom.pageIndex = $event.pageIndex">
                    </mat-paginator>
                </div>
            </div>
            <div class="tableFixHead" style="overflow: scroll">
                <table class="table table-striped">
                    <thead>
                        <tr>
                            <th>#</th>
                            <th>Appointment Id</th>
                            <th>Glamyo Patient Id</th>
                            <th>Glamyo Appointment Id</th>
                            <th>STATUS</th>
                            <th class="tablefixcoloumn">PATIENT NAME</th>
                            <th>PATIENT AGE</th>
                            <th>GENDER</th>
                            <th>ADDRESS</th>
                            <th *ngIf="role!='6'">PATIENT MOBILE</th>
                            <th>LEAD LOCATION</th>
                            <th>CIRCLE</th>
                            <th>CLINIC</th>
                            <th>LEAD OWNER</th>
                            <th>BOOKING DATE</th>
                            <th>INVOICE AMOUNT</th>
                            <th>BOOKING OWNER</th>
                            <!-- <th>Quantity</th> -->
                            <th>PRODUCT & Quantity</th>
                            <th>Bill Copy</th>
                            <th *ngIf="role!='4' && role!='6' && role!='8'">Action</th>
                            <th *ngIf="role=='1'">PRODUCT Tracking</th>

                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let products of productList;let index = index;">
                            <td>{{(pageIndex*perpage)+index+1}}</td>
                            <td>{{products.patient_id}}</td>
                            <td>{{products.glamyo_patient_id}}</td>
                            <td>GHPRO{{products.id}}</td>
                            <td>
                                <span class='p-2 badge' [ngClass]="{'badge-success':products.status==1}"
                                *ngIf="products.status==1">New</span>
                                <span class='p-2 badge' [ngClass]="{'badge-primary':products.status==2}"
                                *ngIf="products.status==2">Verified</span>
                                <span class='p-2 badge' [ngClass]="{'badge-info':products.status==3}"
                                *ngIf="products.status==3">Pending</span>
                                <span class='p-2 badge' [ngClass]="{'badge-secondary':products.status==4}"
                                *ngIf="products.status==4">RTO</span>
                                <span class='p-2 badge' [ngClass]="{'badge-warning':products.status==5}"
                                *ngIf="products.status==5">Delivered</span>
                                <span class='p-2 badge' [ngClass]="{'badge-danger':products.status==6}"
                                *ngIf="products.status==6">Postponed</span>
                                <span class='p-2 badge' [ngClass]="{'badge-dark':products.status==7}"
                                *ngIf="products.status==7">Dispatched</span>
                                <span class='p-2 badge' [ngClass]="{'badge-danger':products.status==8}"
                                *ngIf="products.status==8">Cancelled</span>
                            </td>

                            <td class="tablefixcoloumn">{{products.patient_name}}</td>
                            <td>{{products.patient_age}}</td>
                            <td>{{products.gender}}</td>
                            <td><div style="width: 250px;">{{products.address}}</div></td>
                            <td *ngIf="role!='6'">{{products.patient_mobile}}</td>
                            <td>{{products.city_name}}</td>
                            <td>{{products.circle_name}}</td>
                            <td><div style="width: 150px;">{{products.hospital_name}}</div></td>
                            <td>{{products.bd_name}}</td>
                            <td>{{products.booking_date*1000|date:'d MMM, yyyy'}}</td>
                            <td>{{products.invoice_amount}}</td>
                            <td>{{products.product_booking_owner}}</td>
                            <!-- <td>{{products.quantity}}</td> -->
                            <td>
                                <div class="prodetail" *ngIf="products.product_details">
                                    <span *ngFor="let productDetails of products.product_details;let i = index;">
                                         <span> {{productDetails.product_id}} <span>=</span> {{productDetails.quantity}} </span><br>
                                    </span>
                                </div>
                            </td>
                            <td>
                                <div *ngIf="products.bill_copy.length > 0; else noBillCopy">
                                    <span *ngFor="let aDlink of products.bill_copy"><a
                                            href="{{sc3Url+aDlink.bill_copy}}" target="_blank">View</a><br></span>
                                </div>
                                <ng-template #noBillCopy>
                                    Not uploaded
                                </ng-template>
                            </td>
                            <td *ngIf="role!='4' && role!='6' && role!='8'">
                                <div class="dropdown">
                                   <button class="btn btn-secondary dropdown-toggle" type="button" lead_id="{{products.lead_id}}" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">Action
                                   </button>
                                   <div class="dropdown-menu" aria-labelledby="{{products.lead_id}}" style="height: 100px; overflow: scroll;">
                                       <a class="dropdown-item" (click)="updateProductDetails(products.lead_id)"><i class="fa fa-pen"></i> Update Details
                                       </a>
                                       <a *ngIf="role=='1'" class="dropdown-item" (click)="openProductHistoryPopup(products.id)"><i class="fa fa-eye"></i> History
                                       </a>
                                       <a class="dropdown-item" (click)="viewProduct(products.id)"><i class="fa fa-comments"></i> View Product</a>
                                       <a *ngIf="products.res_order_id==null && (role=='1' && userId=='102')" class="dropdown-item" (click)="createProductOrder(products.lead_id)"><i class="fa fa-pen"></i> Add Product Order Details
                                       </a> 
                                       <a *ngIf="products.res_order_id!=null && (role=='1' && userId=='102')" class="dropdown-item" (click)="updateProductOrder(products.res_order_id)"><i class="fa fa-pen"></i> Update Product Order Details
                                       </a>
                                   </div>
                               </div>
                           </td>
                           <td *ngIf="role=='1'">
                            <button type="button" class="btn btn-success" (click)="productTracking(products.id,index)"><i *ngIf="showTrackingLoading[index]" class="fa fa-spin fa-spinner"></i> Tracking</button>
                           </td>
                        </tr>
                        <tr *ngIf="loading">
                            <td colspan="20" class="text-center"><i class="fa fa-spin fa-spinner fa-2x"></i></td>
                        </tr>
                        <tr *ngIf="loaded && !productList.length">
                            <td colspan="20"><i class="far fa-frown"></i> Data not found</td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <mat-paginator #paginatorBottom [length]="length" [pageSizeOptions]="pageSizeOptions" [pageSize]="perpage"
                (page)="pageEvent = getServerData($event);paginatorTop.pageIndex = $event.pageIndex"></mat-paginator>
        </div>
    </div>
</div>


<!-- The Modal to view Product history -->
<div class="modal fade" id="myHistoryModal">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header">
            <h4 class="modal-title">Update Product History</h4>
            <button type="button" class="close" (click)="closeHistoryPopup()"></button>
        </div>
        <div class="modal-body history_modal">
            <table class="table table-hover table-outline table-vcenter text-nowrap card-table">
              <tbody>
                  <tr *ngFor="let updatedLog of updatedLodData">
                      <td class="no-padding-bottom">
                          <div class="small_text" [innerHTML]="updatedLog.message | safe:'html'"></div>
                          <div class="small text-muted small_text_creation">
                              <i class="fas fa-clock"></i> {{updatedLog.created_at*1000|date:'dMMM, yyyy h:mm aa'}}
                          </div>
                      </td>
                  </tr>
                  <tr *ngIf="!updatedLodData.length && history_loaded">
                      <td>No history found</td>
                  </tr>
                  <tr *ngIf="history_loading">
                      <td><i class="fa fa-spin fa-spinner"></i></td>
                  </tr>
              </tbody>
          </table>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn" (click)="closeHistoryPopup()">Close</button>
        </div>
      </div>
    </div>
  </div>



  <!-- The Modal to view Product -->
<div class="modal fade" id="myModal">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
  
        <!-- Modal Header -->
        <div class="modal-header">
          <h4 class="modal-title">Product Schedule</h4>
          <button type="button" class="close" (click)="hideModal('1')"></button>
        </div>
  
        <!-- Modal body -->
        <div class="modal-body"id="pdfTable" #pdfTable>
          <div><h3><span style="color:#0f74b2">Glamyo</span>&nbsp;<span style="color:#69bb45">Health</span></h3></div>
          <table>
            <tr>
            <th colspan="2">Product Details</th>
            </tr>
            <tr>
                <td><strong>Product Id -</strong></td>
                <td> GHPRO{{productDetail.product_id}}</td>
            </tr>
            <tr>
                <td><strong>Patient Name -</strong></td>
                <td>{{productDetail.patient_name}}</td>
            </tr>
            <tr>
                <td><strong>Age -</strong></td>
                <td>{{productDetail.patient_age}}</td>
            </tr>
            <tr>
                <td><strong>Gender -</strong></td>
                <td>{{productDetail.gender}}</td>
            </tr>
            <tr>
                <td><strong>Medical Coordinator -</strong></td>
                <td>{{productDetail.bd_name}}</td>
            </tr>
            <tr>
                <td><strong>Location -</strong></td>
                <td>{{productDetail.circle_name}}</td>
            </tr>
            <tr>
                <td><strong>Address -</strong></td>
                <td>{{productDetail.address}}</td>
            </tr>
            <tr>
                <td><strong>Booking Date -</strong></td>
                <td>{{productDetail.booking_date*1000 | date:'dd MMM, yyyy'}}</td>
            </tr>
            <tr>
                <td><strong>Product Quantity -</strong></td>
                <td *ngIf="productDetail.product_details">
                <div class="" *ngIf="productDetail.product_details">
                    <span *ngFor="let productDetails of productDetail.product_details;let i = index;">
                        <span> {{productDetails.product_name}} <span>=</span> {{productDetails.quantity}} </span><br>
                    </span>
                </div>
                </td>
            </tr>
            <tr>
                <td><strong>Invoice Amount -</strong></td>
                <td>{{productDetail.invoice_amount}}</td>
            </tr>
             
          </table>
        </div>
  
        <!-- Modal footer -->
        <div class="modal-footer">
          <button class="btn btn-primary" (click)="downloadAsPDF()">Share</button>
          <button type="button" class="btn" (click)="hideModal('1')">Close</button>
        </div>
      </div>
    </div>
</div>

<!-- The Modal -->
<div class="modal fade" id="myModalProduct">
    <div class="modal-dialog">
      <div class="modal-content">
  
        <!-- Modal Header -->
        <div class="modal-header">
          <h4 class="modal-title">Import Data </h4>
          <button type="button" class="close" (click)="hideModalProduct()"></button>
        </div>
  
        <!-- Modal body -->
          <div class="modal-body">
              <div class="form-group">
                  <div class="row">
                      <label class="col-sm-12">Upload CSV</label>
                      <input [disabled]="submitted" type="file" #csvUpload (change)="selectFile($event)" class="form-control" />
                  </div>
                  <span *ngIf="submitted"><i class="fa fa-spin fa-spinner"></i> Uploading...</span>
              </div>
          </div>
  
        <!-- Modal footer -->
        <div class="modal-footer">
          <button type="button" class="btn" (click)="hideModalProduct()">Close</button>
        </div>
      </div>
    </div>
  </div>

  <!-- The Modal -->
<div class="modal fade" id="myModalProduct2">
    <div class="modal-dialog">
      <div class="modal-content">
  
        <!-- Modal Header -->
        <div class="modal-header">
          <h4 class="modal-title">Import Data </h4>
          <button type="button" class="close" (click)="hideModalProduct2()"></button>
        </div>
  
        <!-- Modal body -->
          <div class="modal-body">
              <div class="form-group">
                  <div class="row">
                      <label class="col-sm-12">Upload CSV</label>
                      <input [disabled]="submitted" type="file" #csvUploadWithLeads (change)="selectFileWithLeads($event)" class="form-control" />
                  </div>
                  <span *ngIf="submitted"><i class="fa fa-spin fa-spinner"></i> Uploading...</span>
              </div>
          </div>
  
        <!-- Modal footer -->
        <div class="modal-footer">
          <button type="button" class="btn" (click)="hideModalProduct2()">Close</button>
        </div>
      </div>
    </div>
</div>